import axiosClient from "../utils/axiosClient";

export const updateSkills = (skills)=>axiosClient.put('/skills/addSkills', skills)